import { addMonths, format, isAfter, isSunday as getIsSunday } from 'date-fns';

export enum TabsType {
  Company = 'company',
  Earnings = 'earnings',
  Economics = 'economics',
}

export const isDateBeyondThreeMonths = (date: Date) => {
  const dateAhead = addMonths(new Date(), 3);
  return isAfter(date, dateAhead);
};

export const isDateBeyondThreeMonthsAndSunday = (date: Date) => {
  const dateAhead = addMonths(new Date(), 3);
  const isSunday = getIsSunday(date);
  return isSunday && isAfter(date, dateAhead);
};

export const formatEventDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};
